@if (!appSettings.isMobile()) {
<div>
    <div class="row mb-3 align-items-end">
        <div class="col-md-6">
            <ng-select [items]="rules" [selectableGroup]="true" [hideSelected]="false" bindLabel="description"
                [multiple]="true" [closeOnSelect]="false" [hideSelected]="true" [dropdownPosition]="'bottom'"
                bindValue="slug" placeholder="Filtrar Reglas" (change)="changeSelect()" [(ngModel)]="rulesSelected">
            </ng-select>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
            <ng-content></ng-content>
        </div>
    </div>

    <div>
        <div class="table-responsive table-data mb-3">
            <table class="table table-hover table-sm">
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Valor</th>
                        <th>Rango Min</th>
                        <th>Rango Max</th>
                        <th>Tipo Valor</th>
                        <th><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>

                <tbody>
                    @if(isLoading){
                    @for( i of rows ;track $index){
                    <tr class="tr-custom">
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                        <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                    </tr>
                    }
                    }

                    @for(rule of filteredRules; track rule.id) {
                    <tr>
                        <td><span>{{ rule.slug || rule.code }}</span></td>
                        <td class="text-nowrap"><span>{{ rule.description}}</span></td>
                        <td><span>{{ rule.value}}</span></td>
                        <td><span>{{ rule.minRange}}</span></td>
                        <td><span>{{ rule.maxRange}}</span></td>
                        <td><span>{{ rule.typeValue}}</span></td>
                        <td>
                            <button class="btn btn-outline-primary btn-xs" (click)="selectRule(rule)">
                                <i class="fas fa-pencil"></i>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>

            @if(filteredRules?.length==0 && !isLoading){
            <div class="m-l-10 mb-2">
                <em>No hay datos</em>
            </div>
            }
        </div>
    </div>
</div>
} @else {
<app-mobile-footer>
    <input type="search"
           class="form-control mobile-footer-search"
           placeholder="Buscar regla..."
           [(ngModel)]="searchText"
           (ngModelChange)="changeSelect()">
</app-mobile-footer>
<div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading) { ({{ filteredRules.length }}) }
    </span>
</div>
<div class="mobile-cards-scroll">
    @if (isLoading) {
        @for (i of rows; track $index) {
            <app-list-card [isLoading]="true"></app-list-card>
        }
    } @else {
        @for (rule of filteredRules; track rule.id) {
            <app-list-card
                [isShortcut]="true"
                (click)="selectRule(rule)">
                <div cardTitle class="fw-bold text-dark text-truncate">
                    {{ rule.description }}
                </div>
                <div cardBadge>
                    <span class="badge text-bg-secondary">{{ rule.slug || rule.code }}</span>
                </div>
                <div class="row g-1 text-muted small">
                    <div class="col-6 text-end">
                        <span class="text-muted">Valor</span>
                        <div class="fw-semibold text-dark">{{ rule.value }}</div>
                    </div>
                    <div class="col-6">
                        <span class="text-muted">Rango</span>
                        <div>{{ rule.minRange ?? '—' }} / {{ rule.maxRange ?? '—' }}</div>
                    </div>
                    <div class="col-6 text-end">
                        <span class="text-muted">Tipo</span>
                        <div>{{ rule.typeValue || '—' }}</div>
                    </div>
                </div>
            </app-list-card>
        }
    }
    @if (!isLoading && filteredRules.length === 0) {
        <div class="card border-0 shadow-sm p-4 text-center my-2">
            <i class="fas fa-sliders-h fa-3x text-muted opacity-50 mb-2"></i>
            <h6 class="text-muted mb-1">Sin reglas</h6>
        </div>
    }
</div>
}
